import { motion } from 'framer-motion'
import { useLanguage } from '../../../contexts/LanguageContext'
import MobileSlideShell from './MobileSlideShell'
import { fadeScaleProps, M_CARD } from './mobileMotion'

export default function Slide10M() {
  const { t } = useLanguage()
  const s = t.slides.slide10

  return (
    <MobileSlideShell>
      <motion.h2
        {...fadeScaleProps(0)}
        className="text-center text-[26px] font-semibold leading-tight tracking-tight text-[#1B2A6B]"
      >
        {s.headline}
      </motion.h2>

      <motion.div {...fadeScaleProps(0.08)} className={M_CARD}>
        <div className="mb-4 flex items-center gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#22A756]/12">
            <svg viewBox="0 0 28 28" fill="none" className="h-6 w-6">
              <path
                d="M20 3 Q26 3 26 9 Q26 15 20 18 L8 28 Q5 31 2 28 Q-1 25 2 22 L14 12 Q16 5 20 3Z"
                stroke="#22A756"
                strokeWidth="2"
                fill="rgba(34,167,86,0.12)"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h3 className="text-[19px] font-semibold text-[#1B2A6B]">{s.installTitle}</h3>
        </div>
        <ul className="flex flex-col gap-3">
          {s.installItems?.map((item, i) => (
            <li key={i} className="flex gap-3 text-[16px] leading-relaxed text-[#1B2A6B]/70">
              <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#22A756]" />
              {item}
            </li>
          ))}
        </ul>
      </motion.div>

      <motion.div {...fadeScaleProps(0.16)} className={M_CARD}>
        <div className="mb-4 flex items-center gap-3">
          <div className="flex h-11 w-11 shrink-0 items-center justify-center rounded-xl bg-[#1B2A6B]/10">
            <svg viewBox="0 0 24 34" fill="none" className="h-7 w-5">
              <path
                d="M12 4 Q5 14 5 22 Q5 31 12 32 Q19 31 19 22 Q19 14 12 4Z"
                stroke="#1B2A6B"
                strokeWidth="2"
                fill="rgba(27,42,107,0.07)"
                strokeLinejoin="round"
              />
            </svg>
          </div>
          <h3 className="text-[19px] font-semibold text-[#1B2A6B]">{s.maintainTitle}</h3>
        </div>
        <ul className="flex flex-col gap-3">
          {s.maintainItems?.map((item, i) => (
            <li key={i} className="flex gap-3 text-[16px] leading-relaxed text-[#1B2A6B]/70">
              <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#1B2A6B]/35" />
              {item}
            </li>
          ))}
        </ul>
      </motion.div>
    </MobileSlideShell>
  )
}
